import { Group } from '@forwardflow/ui-v2'
import { CloseIcon, MailIcon } from '@forwardflow/icons'
import { TFubUser } from '@forwardflow/types/onboarding'

interface TeamMemberCardProps {
   user: TFubUser
   onRemove: (userId: string) => void
   isReadOnly?: boolean
}

export const TeamMemberCard = ({
   user,
   onRemove,
   isReadOnly = false,
}: TeamMemberCardProps) => {
   return (
      <Group
         justify="space-between"
         className="rounded-lg border border-white/20 bg-white/[0.02] p-3"
      >
         <Group>
            <Group
               className="rounded-lg border border-[rgba(142,81,255,0.3)] bg-gradient-to-br from-[rgba(79,57,246,0.3)] to-[rgba(127,34,254,0.3)] w-8 h-8"
               justify="center"
               align="center"
            >
               <MailIcon width={18} color="#A684FF" />
            </Group>
            <p className="text-white/90 font-medium text-sm">
               {user.firstName} {user.lastName}
            </p>
            <p className="text-[#99A1AF] text-sm font-medium">{user.email}</p>
         </Group>
         {!isReadOnly && (
            <CloseIcon
               width={16}
               height={16}
               className="cursor-pointer"
               onClick={() => onRemove(String(user.id))}
            />
         )}
      </Group>
   )
}

